'use client';

import { Suspense } from 'react';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

import { AuthOtpForm } from '@/components/auth/otp-form';
import { useTranslations } from '@/components/language-provider';

export default function LoginPage() {
  return (
    <Suspense fallback={null}>
      <LoginContent />
    </Suspense>
  );
}

function LoginContent() {
  const { messages } = useTranslations();
  const content = messages.auth.otp;
  const searchParams = useSearchParams();
  const returnTo = searchParams.get('returnTo') ?? undefined;
  const signupHref = returnTo ? `/auth/signup?returnTo=${encodeURIComponent(returnTo)}` : '/auth/signup';

  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center px-6 py-16">
      <AuthOtpForm mode="login" returnTo={returnTo} />
      <p className="mt-8 text-sm text-muted-foreground">
        {content.loginNeedAccount}{' '}
        <Link className="text-primary underline hover:text-primary/80" href={signupHref}>
          {content.loginNeedAccountCta}
        </Link>
      </p>
    </div>
  );
}
